import { DomainInstance, Instance } from '../instance';
import { AttachmentApi } from '../../../api/models/common/attachment-api';

export class Attachment
{
    attachmentId: string;
    device: string;
    volumeIdAlso: string;
    serverId: string;
    volumeId: string;
    instance?: Instance;

    public static mapperFromApi (source: AttachmentApi): Attachment
    {
        const target = new Attachment();

        Object.assign(target, source);

        if (source.instance)
        {
            target.instance = DomainInstance.mapperFromApi(source.instance);
        }

        return target;
    }
}
